<template>
  <v-app class="futuristic-app">
    <div class="mesh-background">
      <canvas ref="particleCanvas" class="particle-canvas"></canvas>
      <div class="circle c1"></div>
      <div class="circle c2"></div>
      <div class="circle c3"></div>
      <div class="watermark-container">
        <img src="/images/bgsub.png" class="bg-watermark-baru" />
      </div>
    </div>

    <v-app-bar
      app
      flat
      class="ultra-glass-header mt-4 mx-auto rounded-pill"
      height="85"
      style="max-width: 1200px"
    >
      <v-btn icon color="white" class="ml-2" @click="$router.back()"
        ><v-icon>mdi-arrow-left</v-icon></v-btn
      >
      <v-toolbar-title class="black--text ml-2">
        <div class="font-weight-black letter-spacing-2">
          {{ $route.params.group_name.toUpperCase() }}
        </div>
        <div class="gold--text text-overline" style="line-height: 1">
          LIVE_SIGNAL_MONITORING // SECURE_FEED
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip color="#CFA22D" label small class="black--text font-weight-black mr-4">
        <v-icon left x-small color="black">mdi-broadcast</v-icon>
        STREAM_MODE
      </v-chip>
    </v-app-bar>

    <v-main>
      <v-container class="py-12 content-layer" style="max-width: 1200px">
        <div class="d-flex align-center mb-8 px-4">
          <div class="line-decorator-gold mr-4"></div>
          <h2 class="black--text text-overline letter-spacing-4">
            TERMINAL_DIREKTORI_SINYAL
          </h2>
          <v-spacer></v-spacer>
          <div class="black--text text-caption opacity-4 font-italic">
            // ACTIVE_NODES: {{ filteredItems.length }}
          </div>
        </div>

        <v-row v-if="filteredItems.length > 0">
          <v-col v-for="item in filteredItems" :key="item.id" cols="12" sm="6" md="4">
            <v-card
              class="monitor-tile-v2 overflow-hidden clickable-card"
              ripple
              @click="openIframe(item.link_layanan)"
            >
              <div class="tile-header d-flex align-center px-4 py-2">
                <div class="status-dot pulse-green mr-2"></div>
                <span class="black--text text-overline letter-spacing-1"
                  >SIGNAL_ID: {{ item.id }}</span
                >
                <v-spacer></v-spacer>
                <v-icon x-small color="rgba(255,255,255,0.3)">mdi-dots-horizontal</v-icon>
              </div>

              <div class="feed-preview-box">
                <v-img :src="item.full_url" height="180" cover class="img-zoom">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular
                        indeterminate
                        color="#018c74"
                        size="20"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                  <div class="hud-overlay">
                    <div class="corner-tl"></div>
                    <div class="corner-tr"></div>
                    <div class="corner-bl"></div>
                    <div class="corner-br"></div>
                  </div>
                  <div class="cam-label">CAM_0{{ item.id }}</div>
                </v-img>
                <div class="scan-line-vignette"></div>
              </div>

              <div class="pa-4 bg-glass-dark">
                <div
                  class="gold--text text-caption font-weight-black mb-1 letter-spacing-1"
                >
                  // ACCESS_POINT: {{ item.nama_layanan.toUpperCase() }}
                </div>
                <div
                  class="black--text text-body-2 font-weight-bold headline-shadow text-truncate"
                >
                  {{ item.deskripsi }}
                </div>

                <div class="d-flex align-center mt-3 pt-3 border-top-gray">
                  <v-icon x-small color="#018c74" class="mr-1">mdi-link-variant</v-icon>
                  <span class="cyber-link-text text-overline opacity-7"
                    >LINK_ESTABLISHED</span
                  >
                  <v-spacer></v-spacer>
                  <v-btn x-small icon color="#CFA22D"
                    ><v-icon>mdi-eye-outline</v-icon></v-btn
                  >
                </div>
              </div>

              <div class="tech-glow-line"></div>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-else class="text-center mt-15">
          <v-col>
            <v-icon size="100" color="rgba(207, 162, 45, 0.1)">mdi-signal-off</v-icon>
            <div class="black--text opacity-5 mt-4 letter-spacing-4 font-weight-bold">
              NO_SIGNALS_DETECTED_IN_SECTOR
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-dialog
      v-model="iframeDialog"
      fullscreen
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card class="black-obsidian">
        <v-toolbar flat dark color="#001a16" class="border-bottom-gold">
          <v-btn icon @click="iframeDialog = false" class="hover-rotate">
            <v-icon color="#CFA22D">mdi-close-circle-outline</v-icon>
          </v-btn>
          <v-toolbar-title class="text-overline letter-spacing-2 black--text">
            LIVE_FEED_VIEWER // <span class="gold--text">SYSTEM_READY</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="d-none d-md-flex align-center mr-4">
            <div class="stream-indicator mr-4"><span>REC</span></div>
          </div>
          <v-chip
            color="rgba(1, 140, 116, 0.1)"
            label
            small
            class="green--text font-weight-black border-green-thin"
          >
            SECURE_CONNECTION
          </v-chip>
        </v-toolbar>

        <div class="iframe-container-premium">
          <iframe
            :src="selectedUrl"
            frameborder="0"
            allowfullscreen
            class="full-iframe"
          ></iframe>
          <div class="iframe-vignette"></div>
        </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import { getLayananPublik } from "@/api/androidInitApi";

export default {
  data: () => ({
    items: [],
    iframeDialog: false,
    selectedUrl: "",
    particles: [],
    ctx: null,
    animationId: null,
  }),
  computed: {
    filteredItems() {
      return this.items.filter(
        (i) =>
          i.opd_id == this.$route.params.opd_id &&
          i.nama_layanan == this.$route.params.group_name
      );
    },
  },
  mounted() {
    this.initParticles();
    window.addEventListener("resize", this.resizeCanvas);
    this.fetchData();
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationId);
    window.removeEventListener("resize", this.resizeCanvas);
  },
  methods: {
    async fetchData() {
      try {
        this.items = (await getLayananPublik()) || [];
      } catch (e) {
        console.error("Data Link Severed", e);
      }
    },
    initParticles() {
      const canvas = this.$refs.particleCanvas;
      this.ctx = canvas.getContext("2d");
      this.resizeCanvas();
      this.particles = Array.from({ length: 40 }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        radius: Math.random() * 2 + 1,
      }));
      this.animate();
    },
    resizeCanvas() {
      const canvas = this.$refs.particleCanvas;
      if (canvas) {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }
    },
    animate() {
      this.ctx.clearRect(
        0,
        0,
        this.$refs.particleCanvas.width,
        this.$refs.particleCanvas.height
      );
      this.particles.forEach((p, i) => {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0 || p.x > this.$refs.particleCanvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > this.$refs.particleCanvas.height) p.vy *= -1;
        this.ctx.beginPath();
        this.ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        this.ctx.fillStyle = "rgba(1, 140, 116, 0.4)";
        this.ctx.fill();
        for (let j = i + 1; j < this.particles.length; j++) {
          const p2 = this.particles[j];
          const dist = Math.hypot(p.x - p2.x, p.y - p2.y);
          if (dist < 150) {
            this.ctx.beginPath();
            this.ctx.moveTo(p.x, p.y);
            this.ctx.lineTo(p2.x, p2.y);
            this.ctx.strokeStyle = `rgba(1, 140, 116, ${0.3 - dist / 400})`;
            this.ctx.lineWidth = 0.5;
            this.ctx.stroke();
          }
        }
      });
      this.animationId = requestAnimationFrame(this.animate);
    },
    transformUrl(url) {
      if (url.includes("cctv.bondowosokab.go.id")) {
        try {
          const urlObj = new URL(url);
          const mid = urlObj.searchParams.get("mid");
          if (mid) {
            return `https://cctv.bondowosokab.go.id/cgi-bin/nph-zms?scale=100&mode=jpeg&maxfps=30&monitor=${mid}&user=view&pass=K0minfo&rand=${Math.random()}`;
          }
        } catch (e) {
          return url;
        }
      }
      return url;
    },
    openIframe(url) {
      this.selectedUrl = this.transformUrl(url);
      this.iframeDialog = true;
    },
  },
};
</script>

<style scoped>
.mesh-background {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #f2f7fb;
  z-index: 0;
  overflow: hidden;
}

.bg-watermark-baru {
  width: 140%;
  height: 100%;
}
.particle-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}
.watermark-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 2;
}
.bg-watermark-center {
  width: 40%;
  opacity: 0.05;
}
.circle {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.15;
  z-index: 2;
}
.c1 {
  width: 600px;
  height: 600px;
  background: linear-gradient(90deg, #016b62 0%, #018c74 45%, #8bcdc6 100%);
  top: -10%;
  left: -10%;
}
.c2 {
  width: 500px;
  height: 500px;
  background: #cfa22d;
  bottom: -5%;
  right: -5%;
}

.ultra-glass-header {
  background: rgba(255, 255, 255, 0.03) !important;
  backdrop-filter: blur(25px);
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;
}

.monitor-tile-v2 {
  background: #fafafa !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 16px !important;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
}

.monitor-tile-v2:hover {
  transform: translateY(-8px);
  border-color: #cfa22d !important;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.6);
}

.tile-header {
  background: rgba(1, 140, 116, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.feed-preview-box {
  position: relative;
  overflow: hidden;
}
.img-zoom {
  transition: 0.8s ease;
}
.monitor-tile-v2:hover .img-zoom {
  transform: scale(1.1);
}

.hud-overlay div {
  position: absolute;
  width: 15px;
  height: 15px;
  border-color: rgba(207, 162, 45, 0.5);
  border-style: solid;
}
.corner-tl {
  top: 10px;
  left: 10px;
  border-width: 2px 0 0 2px;
}
.corner-tr {
  top: 10px;
  right: 10px;
  border-width: 2px 2px 0 0;
}
.corner-bl {
  bottom: 10px;
  left: 10px;
  border-width: 0 0 2px 2px;
}
.corner-br {
  bottom: 10px;
  right: 10px;
  border-width: 0 2px 2px 0;
}

.cam-label {
  position: absolute;
  top: 10px;
  right: 35px;
  background: rgba(255, 0, 0, 0.6);
  color: white;
  font-size: 8px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 4px;
  letter-spacing: 1px;
}

.bg-glass-dark {
  background: #fafafa;
}
.border-top-gray {
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.pulse-green {
  background: linear-gradient(90deg, #016b62 0%, #018c74 45%, #8bcdc6 100%);
  box-shadow: 0 0 0 rgba(1, 140, 116, 0.4);
  animation: pulse-green 2s infinite;
}
@keyframes pulse-green {
  0% {
    box-shadow: 0 0 0 0 rgba(1, 140, 116, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(1, 140, 116, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(1, 140, 116, 0);
  }
}

.tech-glow-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0%;
  height: 2px;
  background: #cfa22d;
  transition: 0.5s ease;
}
.monitor-tile-v2:hover .tech-glow-line {
  width: 100%;
}

.scan-line-vignette {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.2) 50%),
    linear-gradient(
      90deg,
      rgba(255, 0, 0, 0.03),
      rgba(0, 255, 0, 0.01),
      rgba(0, 0, 255, 0.03)
    );
  background-size: 100% 4px, 3px 100%;
  pointer-events: none;
}

.line-decorator-gold {
  width: 45px;
  height: 4px;
  background: #cfa22d;
  border-radius: 2px;
}
.headline-shadow {
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
.cyber-link-text {
  color: #018c74;
  font-weight: bold;
  font-family: "Courier New", monospace;
  font-size: 8px;
}
.gold--text {
  color: #cfa22d !important;
}
.letter-spacing-1 {
  letter-spacing: 1px;
}
.letter-spacing-2 {
  letter-spacing: 2px;
}
.letter-spacing-4 {
  letter-spacing: 4px;
}

.black-obsidian {
  background: #000 !important;
}
.border-bottom-gold {
  border-bottom: 3px solid #cfa22d !important;
}
.iframe-container-premium {
  width: 100%;
  height: calc(100vh - 85px);
  position: relative;
  overflow: hidden;
  background: #000;
}
.full-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.iframe-vignette {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.8);
  pointer-events: none;
}
.stream-indicator {
  color: #ff0000;
  font-weight: bold;
  font-size: 10px;
  display: flex;
  align-items: center;
}
.stream-indicator::before {
  content: "";
  width: 8px;
  height: 8px;
  background: #ff0000;
  border-radius: 50%;
  margin-right: 8px;
  animation: blink 1s infinite;
}
@keyframes blink {
  50% {
    opacity: 0;
  }
}
.hover-rotate:hover {
  transform: rotate(90deg);
  transition: 0.4s;
}
.border-green-thin {
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
</style>
